import { render, staticRenderFns } from "./ImpactActivities.vue?vue&type=template&id=34542cbd"
import script from "./ImpactActivities.vue?vue&type=script&lang=js"
export * from "./ImpactActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports